import React from 'react';
import styled from 'styled-components';

const SubmitButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SubmitButtonWrapper: React.FC<{ children: React.ReactNode }> = (props) => {
    return (
        <SubmitButton>
            {props.children}
        </SubmitButton>
    );
};
